/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsmedianpeople2Inputs */

const en_statsmedianpeople2 = /** @type {(inputs: Statsmedianpeople2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Median people per plan`)
};

const de_statsmedianpeople2 = /** @type {(inputs: Statsmedianpeople2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Median Personen pro Plan`)
};

/**
* | output |
* | --- |
* | "Median people per plan" |
*
* @param {Statsmedianpeople2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsmedianpeople2 = /** @type {((inputs?: Statsmedianpeople2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsmedianpeople2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsmedianpeople2(inputs)
	return de_statsmedianpeople2(inputs)
});
export { statsmedianpeople2 as "statsMedianPeople" }